import type { Env, Content } from "./types";

import configBase from "./base";
import { BRAND_ALL } from "./brand";
import defaults from "../content/default";
import base from "../content/base";
import tvgBrand from "../content/brand";

export default (env: Env): Content => {
  const confDefault: Content = {
    tvg: defaults,
    pabets: defaults,
    iowa: defaults,
    "4njbets": defaults,
    fdr: defaults
  };

  const content: {
    production: Content;
    staging: Content;
    qa: Content;
    "aws-int": Content;
    "aws-stg": Content;
    "aws-prd": Content;
  } = {
    production: { ...confDefault },
    staging: { ...confDefault },
    qa: { ...confDefault },
    "aws-int": { ...confDefault },
    "aws-stg": { ...confDefault },
    "aws-prd": { ...confDefault }
  };

  Object.keys(content).forEach((envName) =>
    BRAND_ALL.map((brand) => {
      // @ts-ignore
      const baseConf = base[envName];
      // @ts-ignore
      const brandConf = tvgBrand[envName][brand];
      // @ts-ignore
      content[envName][brand] = {
        // @ts-ignore
        ...content[envName][brand],
        ...baseConf,
        ...brandConf
      };
      return brand;
    })
  );

  const config = BRAND_ALL.reduce(
    (acc, brand) => ({
      ...acc,
      // @ts-ignore
      [brand]: configBase.config(content[env][brand])
    }),
    {}
  );

  // @ts-ignore
  return config;
};
